import React from 'react'

function Product2() {
  return (
    <div>Product2</div>
  )
}

export default Product2